import React, { Fragment } from "react"

import { Field, useFormikContext } from "formik"
import { getInNested } from "../dynamic-form.helper"

function InputText(props) {
  const { id, label, name, value, placeholder, rows, errorMessage, fieldData, isNestedFieldName, isRequired, ...otherProps } = props
  const { errors, touched } = useFormikContext()
  const normalizedNameKey = isNestedFieldName ? name : `['${name}']`

  const shouldRenderTextArea = rows && rows > 1
  // Free-text-with-suggestions (ROLE_INPUT): a native <datalist> gives type-ahead without constraining
  // input — the user can still type anything. No datalist when there are no suggestions (plain STRING).
  const suggestions = Array.isArray(fieldData?.suggestions)
    ? [...new Set(fieldData.suggestions.map((s) => String(s ?? "").trim()).filter(Boolean))] // dedupe → no duplicate <option> keys
    : []
  const datalistId = suggestions.length ? `${id}-suggestions` : undefined
  return (
    <Fragment>
      <div className="form-block-wrapper">
        <div className="custom-form-block flex-grow-1">
          <fieldset disabled={fieldData?.enabled === false}>
            <label htmlFor={id} className="form-label">
              {label} {isRequired && <sup>*</sup>}
            </label>
            <div className="input-group custom-field has-validation">
              <Field
                type="text"
                component={shouldRenderTextArea ? "textarea" : undefined}
                rows={shouldRenderTextArea ? rows : undefined}
                style={shouldRenderTextArea ? { resize: "none" } : undefined}
                id={id}
                className={`form-control ${
                  getInNested(touched, name, isNestedFieldName) && getInNested(errors, name, isNestedFieldName) ? "is-invalid" : ""
                }`}
                name={normalizedNameKey}
                // value={value}
                placeholder={placeholder}
                list={datalistId}
                {...otherProps}
              ></Field>
              {datalistId && (
                <datalist id={datalistId}>
                  {suggestions.map((s) => (
                    <option key={s} value={s} />
                  ))}
                </datalist>
              )}
            </div>
            <div className="invalid-feedback">
              {getInNested(touched, name, isNestedFieldName) && getInNested(errors, name, isNestedFieldName) ? errorMessage : ""}
            </div>
          </fieldset>
        </div>
      </div>
    </Fragment>
  )
}

InputText.propTypes = {}

export default InputText
